'use strict';

var _regeneratorRuntime = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var CID = require('cids');

var UnixFs = require('ipfs-unixfs');

var _require = require('ipld-dag-pb'),
    DAGNode = _require.DAGNode;

var log = require('debug')('ipfs:mfs:utils:with-mfs-root');

var mc = require('multicodec');

var mh = require('multihashes');

var _require2 = require('../../../utils'),
    MFS_ROOT_KEY = _require2.MFS_ROOT_KEY;

var loadMfsRoot = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(context) {
    var cid, buf, node;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return context.repo.datastore.open();

          case 2:
            _context.prev = 2;
            _context.next = 5;
            return context.repo.datastore.get(MFS_ROOT_KEY);

          case 5:
            buf = _context.sent;
            cid = new CID(buf);
            _context.next = 20;
            break;

          case 9:
            _context.prev = 9;
            _context.t0 = _context["catch"](2);

            if (!(_context.t0.code !== 'ERR_NOT_FOUND')) {
              _context.next = 13;
              break;
            }

            throw _context.t0;

          case 13:
            log('Creating new MFS root');
            node = new DAGNode(new UnixFs({
              type: 'directory'
            }).marshal());
            _context.next = 17;
            return context.ipld.put(node, mc.DAG_PB, {
              cidVersion: 0,
              hashAlg: mh.names['sha2-256'] // why can't ipld look this up?

            });

          case 17:
            cid = _context.sent;
            _context.next = 20;
            return context.repo.datastore.put(MFS_ROOT_KEY, cid.buffer);

          case 20:
            log("Loaded MFS root /ipfs/".concat(cid));
            return _context.abrupt("return", cid);

          case 22:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[2, 9]]);
  }));

  return function loadMfsRoot(_x) {
    return _ref.apply(this, arguments);
  };
}();

module.exports = loadMfsRoot;